/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { changeCatSplit } from '../../../redux/ducks/collections';
import { collectionsByType } from '../../../redux/selectors/collections';
import { collectionsGroupType, catSplitAttrsType } from '../../common/types';
import SliderGallery from '../../SliderGallery';
import itemTypePluralize from '../../common/itemTypePluralrize';
import SliderGalleryItem from '../../../models/SliderGalleryItem';
import pageWrapper from '../../containers/MainPage';
import SplitAttributeSelect from './SplitAttributeSelect';
import CollectionFilterSwitcher from './CollectionFilterSwitcher';
import AddItemButton from './AddItemButton';

class CollectionsPage extends React.Component {
  render() {
    const {
      collections,
      catSplitAttributes,
      onChangeSplitAttribute,
      hasAnyItemsInCollection,
    } = this.props;

    if (!hasAnyItemsInCollection) {
      return (
        <div className="columns is-centered">
          <div
            className="column is-half notification is-info has-text-centered"
            style={{ marginTop: '20%' }}
          >
            <h5 className="title is-5">You don&apos;t have any items in your collection yet. </h5>
            <p>
              <Link to="/collections/add" className="button is-inverted is-medium">
                Add your first one now.
              </Link>
            </p>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <CollectionFilterSwitcher />
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <AddItemButton />
            </div>
          </div>
        </div>

        {_.sortBy(_.map(collections, (c, key) => (
          <div key={key}>
            <div className="level" style={{ marginTop: '1rem', marginBottom: 0 }}>
              <div className="level-left">
                <h3 className="title is-4 level-item" style={{ marginBottom: 0 }}>
                  <Link to={`/collections/${key}`}>{itemTypePluralize(key)}</Link>
                </h3>
              </div>

              <div className="level-right">
                <div className="level-item">
                  <SplitAttributeSelect
                    currentSplitAttr={catSplitAttributes[key]}
                    category={key}
                    onChangeAttr={onChangeSplitAttribute}
                  />
                </div>
              </div>
            </div>

            <SliderGallery
              items={SliderGalleryItem.ItemsFromCategory(c, key, catSplitAttributes[key] ? catSplitAttributes[key] : catSplitAttributes.OTHER)}
              splitAttr={catSplitAttributes[key]}
            />
          </div>
        )), (o) => {
            return o.key.toLowerCase().trim();
        })}

      </React.Fragment>
    );
  }
}

CollectionsPage.propTypes = {
  collections: collectionsGroupType,
  catSplitAttributes: catSplitAttrsType.isRequired,
  hasAnyItemsInCollection: PropTypes.bool.isRequired,
  onChangeSplitAttribute: PropTypes.func.isRequired,
};

CollectionsPage.defaultProps = {
  collections: [],
};

function mapStateToProps(state) {
  const {
    collections: { catSplitAttributes },
  } = state;

  const hasAnyItemsInCollection = state.collections.items.length > 0;

  return {
    collections: collectionsByType(state),
    catSplitAttributes,
    hasAnyItemsInCollection,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeSplitAttribute: (category, newAttr) => {
      dispatch(changeCatSplit(category, newAttr));
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(CollectionsPage),
  'My Collection'
);



// WEBPACK FOOTER //
// ./src/components/pages/collections/CollectionsPage.jsx